import React, { useState, useEffect } from "react";


type Props = {
    links: { name: string, url: string }[];
}

const BaseHeader = ({ links }: Props) => {

    return (
        <div className="menuList">
            {links.map(link =>
                <a
                    key={link.url}
                    className={window.location.pathname.replace(/\/$/, '') === link.url.replace(/\/$/, '') ? "link active" : "link"}
                    href={link.url}
                >
                    {link.name}
                    <div className="stroke"></div>
                </a>
            )}
        </div>
    )
}

export default BaseHeader;